var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "bvModal",
      attrs: { id: "availability_form_modal", "no-close-on-backdrop": true },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-header-buttons-container" }, [
                _c("div", { staticClass: "placeholder" }),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("availabilityFormModal.title"))),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "close-modal-btn mr-7",
                    attrs: { id: "availability_form_modal_close_btn" },
                    on: {
                      click: function ($event) {
                        return close()
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "feather feather-x",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "28",
                          height: "28",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("line", {
                          attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                        }),
                        _c("line", {
                          attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-outline",
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("availabilityFormModal.closeBtn")) + " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "bb-btn btn-success",
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("availabilityFormModal.saveBtn")) + " "
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("div", { staticClass: "bb-card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _vm._l(
              _vm.form.helpers.workingHours,
              function (dailyWorkingHours, key) {
                return _c(
                  "div",
                  { key: key, staticClass: "daily-working-hours" },
                  [
                    _c("BBCheckbox", {
                      attrs: { label: _vm.$t("weekdays." + key) },
                      model: {
                        value: dailyWorkingHours.on,
                        callback: function ($$v) {
                          _vm.$set(dailyWorkingHours, "on", $$v)
                        },
                        expression: "dailyWorkingHours.on",
                      },
                    }),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: dailyWorkingHours.on,
                            expression: "dailyWorkingHours.on",
                          },
                        ],
                        staticClass: "daily-working-hours-selects",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "bb-form-group" },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "availabilityFormModal.fromInput.label"
                                  )
                                )
                              ),
                            ]),
                            _c("BBSelect", {
                              attrs: {
                                options: _vm.getTimeOptions(key),
                                placeholderHidden: true,
                              },
                              model: {
                                value: dailyWorkingHours.hours[0].from,
                                callback: function ($$v) {
                                  _vm.$set(
                                    dailyWorkingHours.hours[0],
                                    "from",
                                    $$v
                                  )
                                },
                                expression: "dailyWorkingHours.hours[0].from",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "bb-form-group" },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("availabilityFormModal.toInput.label")
                                )
                              ),
                            ]),
                            _c("BBSelect", {
                              attrs: {
                                options: _vm.getTimeOptions(
                                  key,
                                  dailyWorkingHours.hours[0].from
                                ),
                                placeholderHidden: true,
                              },
                              model: {
                                value: dailyWorkingHours.hours[0].to,
                                callback: function ($$v) {
                                  _vm.$set(
                                    dailyWorkingHours.hours[0],
                                    "to",
                                    $$v
                                  )
                                },
                                expression: "dailyWorkingHours.hours[0].to",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !dailyWorkingHours.on,
                            expression: "!dailyWorkingHours.on",
                          },
                        ],
                        staticClass: "daily-working-hours-closed",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("availabilityFormModal.closedLabel")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.errors.workingHours,
                    expression: "form.errors.workingHours",
                  },
                ],
                staticClass: "bb-invalid-feedback",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("serviceFormModal.validation.error")) +
                    " "
                ),
              ]
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }